export const REPORT_LIST_TABLE_BODY_CONSTS = {
  nothingFounded: 'Ничего не найдено',
  reportExport: 'Экспорт отчета',
  tryChangeRequestParams: 'Попробуйте изменить параметры запроса'
}
